import React, { useCallback } from 'react';

import { Breadcrumbs, Link, Typography, Toolbar, Button, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Icon, Translate } from '@hydra/common/components';

import { sendEvent } from '@hydra/utils/gtm';
import { useI18n } from '@hydra/common/customHooks';

const useStyles = makeStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: 0
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  breadcrumbs: {
    marginTop: 'auto',
    marginBottom: 'auto',
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightSemibold,
    fontSize: theme.typography.fontSizeLarge
  },
  breadcrumbSeparator: {
    margin: 0
  },
  breadcrumbTypography: {
    fontWeight: theme.typography.fontWeightSemibold,
    fontSize: theme.typography.fontSizeLarge
  },
  breadcrumbLink: {
    color: theme.palette.text.primary,
    '&:hover, &:focus, &:active': {
      textDecoration: 'none',
      color: theme.palette.primary.main
    }
  },
  cancel: {
    marginLeft: 'auto'
  }
}));

export default function AddKeywordsPageHeader ({ url }: { url: string }) {
  const { locale } = useI18n();
  const classes = useStyles();

  const handleCancelClick = useCallback(() => {
    sendEvent('keywordtool-cancel-btn');
    window.location.href = `/${locale}/serp/${encodeURIComponent(url)}`;
  }, [locale, url]);

  return (
    <Toolbar className={classes.root}>
      <Container maxWidth='lg' className={classes.headerContainer}>
        <Breadcrumbs
          classes={{
            root: classes.breadcrumbs,
            separator: classes.breadcrumbSeparator
          }}
          separator={
            <Icon
              type='chevron-right'
              color='grey'
              size='md'
            />
          }
        >
          <Link href={`/${locale}/serp/${encodeURIComponent(url)}`} className={classes.breadcrumbLink}>
            <Translate content='serp' />
          </Link>
          <Typography className={classes.breadcrumbTypography}><Translate content='add_keyword' /></Typography>
        </Breadcrumbs>
        <Button
          onClick={handleCancelClick}
          variant='outlined'
          className={classes.cancel}
        >
          <Translate content='cancel' />
        </Button>
      </Container>
    </Toolbar>
  );
}
